/* ACC AI Homepage 18 — behavior */
(function () {
  'use strict';

  /* ---------- Currency: convert "USD price" elements to the session currency ---------- */
  function activeCurrency() {
    try {
      if (window.Shopify && Shopify.currency && Shopify.currency.active) return Shopify.currency.active;
    } catch (e) {}
    return 'USD';
  }
  function currencyRate() {
    try {
      var r = window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate);
      if (r && !isNaN(r)) return r;
    } catch (e) {}
    return 1;
  }
  function formatMoney(amount, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }
  function convertUsdElements() {
    var rate = currencyRate();
    var cur = activeCurrency();
    document.querySelectorAll('.acc18 [data-usd]').forEach(function (el) {
      var usd = parseFloat(el.getAttribute('data-usd'));
      if (isNaN(usd)) return;
      el.textContent = formatMoney(usd * rate, cur);
    });
  }

  /* ---------- Review popup ---------- */
  function initPopup() {
    var modal = document.querySelector('[data-acc18-modal]');
    if (!modal) return;
    var body = modal.querySelector('[data-acc18-modal-body]');
    var authorEl = modal.querySelector('.acc18-modal__author');
    var data = document.querySelector('.acc18-reviews-data');
    var lastFocused = null;

    function open(index, author) {
      var tpl = data && data.querySelector('[data-review-full="' + index + '"]');
      if (!tpl) return;
      body.innerHTML = '';
      body.appendChild(tpl.content.cloneNode(true));
      authorEl.textContent = author || '';
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      lastFocused = document.activeElement;
      var closeBtn = modal.querySelector('.acc18-modal__close');
      if (closeBtn) closeBtn.focus();
    }
    function close() {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
      if (lastFocused && lastFocused.focus) lastFocused.focus();
    }

    document.querySelectorAll('.acc18-rcard').forEach(function (card) {
      var idx = card.getAttribute('data-review-index');
      var author = (card.querySelector('.acc18-rcard__head') || {}).textContent || '';
      card.addEventListener('click', function () { open(idx, author); });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(idx, author); }
      });
    });
    modal.querySelectorAll('[data-acc18-modal-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) close();
    });
  }

  function formatMoneyCents(cents, currency) {
    return formatMoney(Number(cents || 0) / 100, currency || activeCurrency());
  }

  function formatSaveLabel(savedCents, roundSave) {
    var cur = activeCurrency();
    var saved = Number(savedCents || 0);
    if (saved <= 0) return '';
    if (roundSave) saved = Math.round(saved / 100) * 100;
    try {
      return 'SAVE ' + new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: cur,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(saved / 100);
    } catch (e) {
      return 'SAVE ' + Math.round(saved / 100);
    }
  }

  function fetchBundleConfig(proxyBase, productId) {
    var KEY = 'ai_bundle_' + productId;
    var TTL = 5 * 60 * 1000;
    try {
      var raw = sessionStorage.getItem(KEY);
      if (raw) {
        var cached = JSON.parse(raw);
        if (Date.now() - cached.ts < TTL) return Promise.resolve(cached.data);
      }
    } catch (e) {}
    return fetch(proxyBase + '/bundles?product=' + encodeURIComponent(productId), {
      headers: { Accept: 'application/json' }
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        try { sessionStorage.setItem(KEY, JSON.stringify({ data: data, ts: Date.now() })); } catch (e) {}
        return data;
      })
      .catch(function () { return null; });
  }

  /* ---------- Buy form (variant select + subscription + add to cart) ---------- */
  function initBuy() {
    var form = document.querySelector('[data-acc18-buy]');
    if (!form) return;
    var idField = form.querySelector('[data-acc18-variant-id]');
    var propDelivery = form.querySelector('[data-acc18-prop="Delivery"]');
    var propPurchaseType = form.querySelector('[data-acc18-prop="_purchase_type"]');
    var propSubLabel = form.querySelector('[data-acc18-prop="_subscription_label"]');
    var propSubFrequency = form.querySelector('[data-acc18-prop="_subscription_frequency"]');
    var propSubSupply = form.querySelector('[data-acc18-prop="_subscription_supply"]');
    var propCcMode = form.querySelector('[data-acc18-prop="_cc_mode"]');
    var terms = form.querySelector('[data-acc18-terms]');
    var subsRoot = form.querySelector('[data-acc18-subs]');
    var subsCheckbox = form.querySelector('[data-acc18-subs-checkbox]');
    var subsPriceEl = form.querySelector('[data-acc18-subs-price]');
    var subsFreqEl = form.querySelector('[data-acc18-subs-freq]');
    var subsFreqWrap = form.querySelector('[data-acc18-subs-freq-wrap]');
    var subsTooltip = form.querySelector('[data-acc18-subs-tooltip]');
    var subsLabelEl = form.querySelector('[data-acc18-subs-label]');
    var subsBadgeEl = form.querySelector('[data-acc18-subs-badge]');
    var subsFreqPrefixEl = form.querySelector('[data-acc18-subs-freq-prefix]');
    var optionEls = form.querySelectorAll('.acc18-opt');
    var selectedIndex = 0;
    var subChecked = true;
    var bundle = null;
    var mainPrices = [];
    var subEnabled = false;
    var roundSave = false;
    var defaultFreqs = ['Deliver every month', 'Deliver every 2 months', 'Deliver every 4 months'];

    optionEls.forEach(function (opt, i) {
      var radio = opt.querySelector('input[data-acc18-index]');
      mainPrices[i] = {
        variantId: radio ? radio.value : '',
        price: parseInt(opt.getAttribute('data-acc18-price') || '0', 10),
        compare_at_price: parseInt(opt.getAttribute('data-acc18-compare') || '0', 10),
        months: parseInt(opt.getAttribute('data-acc18-months') || '0', 10) || null
      };
      if (opt.classList.contains('is-selected')) selectedIndex = i;
    });

    subEnabled = true;
    if (subsRoot) subsRoot.hidden = !subEnabled;

    function parseAmount(txt) {
      var s = (txt || '').replace(/[^0-9.,]/g, '');
      if (s.indexOf(',') > -1 && s.indexOf('.') > -1) {
        s = s.replace(/,/g, '');
      } else if (s.indexOf(',') > -1) {
        s = s.replace(/\./g, '').replace(',', '.');
      }
      return parseFloat(s);
    }

    var subscriptionDiscountPercent = 20;

    function deliveryPhrase(months) {
      if (!months) return '';
      return months === 1 ? 'every month' : 'every ' + months + ' months';
    }

    function getFrequency(i) {
      var main = mainPrices[i];
      var months = main && main.months;
      if (months) return 'Deliver ' + deliveryPhrase(months);
      if (bundle && bundle.options && bundle.options[i] && bundle.options[i].subscriptionFrequency) {
        return bundle.options[i].subscriptionFrequency;
      }
      return defaultFreqs[i] || defaultFreqs[0];
    }

    function getActivePrice(i) {
      var main = mainPrices[i];
      if (!main) return null;
      if (subEnabled && subChecked) {
        var discounted = Math.round(main.price * (100 - subscriptionDiscountPercent) / 100);
        return {
          price: discounted,
          compare_at_price: main.price
        };
      }
      return { price: main.price, compare_at_price: main.compare_at_price };
    }

    function updateTerms(label) {
      if (!terms || !label) return;
      var priceEl = label.querySelector('[data-acc18-price]') || label.querySelector('.acc18-opt__now');
      if (!priceEl) return;
      var num = parseAmount(priceEl.textContent);
      if (isNaN(num)) return;
      terms.innerHTML = 'Pay in 4 interest-free installments of ' +
        formatMoney(num / 4, activeCurrency()) +
        ' with <strong>Shop&nbsp;Pay</strong>';
    }

    function updateCardPrices() {
      optionEls.forEach(function (opt, i) {
        var active = getActivePrice(i);
        var main = mainPrices[i];
        var priceEl = opt.querySelector('[data-acc18-price]');
        var saveEl = opt.querySelector('[data-acc18-save]');
        if (priceEl && active) {
          priceEl.textContent = formatMoneyCents(active.price);
        }
        if (saveEl && main && active && main.compare_at_price > active.price) {
          saveEl.textContent = formatSaveLabel(main.compare_at_price - active.price, roundSave);
          saveEl.style.display = '';
        } else if (saveEl && (!main || !active || main.compare_at_price <= active.price)) {
          saveEl.style.display = 'none';
        }
      });
    }

    function setProp(el, value) {
      if (!el) return;
      el.value = value;
      el.setAttribute('value', value);
    }

    function syncForm() {
      if (!idField) return;
      var main = mainPrices[selectedIndex];
      var variantId = main ? String(main.variantId || '') : '';
      idField.value = variantId;
      idField.setAttribute('value', variantId);

      var useSub = subEnabled && subChecked;
      var months = main && main.months;

      if (useSub && months) {
        setProp(propDelivery, deliveryPhrase(months));
        setProp(propPurchaseType, 'subscription');
        setProp(propSubLabel, 'Deliver ' + deliveryPhrase(months));
        setProp(propSubFrequency, months + '-month');
        setProp(propSubSupply, months + '-month supply');
        setProp(propCcMode, 'subscription');
      } else {
        setProp(propDelivery, '');
        setProp(propPurchaseType, 'onetime');
        setProp(propSubLabel, '');
        setProp(propSubFrequency, '');
        setProp(propSubSupply, '');
        setProp(propCcMode, 'onetime');
      }
    }

    function updateSubUI() {
      if (!subsRoot || !subEnabled) return;
      var active = getActivePrice(selectedIndex);
      if (subsPriceEl) {
        subsPriceEl.textContent = active ? formatMoneyCents(active.price) : '';
      }
      if (subsFreqEl) subsFreqEl.textContent = getFrequency(selectedIndex);
      var show = subChecked;
      if (subsFreqWrap) subsFreqWrap.hidden = !show;
      if (subsTooltip) subsTooltip.hidden = !show;
    }

    function refresh() {
      syncForm();
      updateCardPrices();
      updateSubUI();
      var selected = optionEls[selectedIndex];
      if (selected) updateTerms(selected);
    }

    form.querySelectorAll('input[data-acc18-index]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        form.querySelectorAll('.acc18-opt').forEach(function (o) { o.classList.remove('is-selected'); });
        var label = radio.closest('.acc18-opt');
        if (label) label.classList.add('is-selected');
        selectedIndex = parseInt(radio.getAttribute('data-acc18-index') || '0', 10);
        refresh();
      });
    });

    if (subsCheckbox) {
      subsCheckbox.addEventListener('change', function () {
        subChecked = subsCheckbox.checked;
        refresh();
      });
    }

    var tooltipTrigger = form.querySelector('[data-acc18-subs-tooltip-trigger]');
    var tooltipContent = subsTooltip && subsTooltip.querySelector('.acc18-subs__tooltip-content');
    if (tooltipTrigger && tooltipContent) {
      tooltipTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = tooltipContent.style.display === 'block';
        tooltipContent.style.display = open ? '' : 'block';
      });
      document.addEventListener('click', function () { tooltipContent.style.display = ''; }, { passive: true });
    }

    if (!document.__acc18PreSubmitGuard) {
      document.__acc18PreSubmitGuard = true;
      var syncBeforeSubmit = function (e) {
        var btn = e.target && e.target.closest && e.target.closest('[type="submit"], .acc18-buy__submit');
        if (!btn || !form.contains(btn)) return;
        syncForm();
      };
      document.addEventListener('mousedown', syncBeforeSubmit, { capture: true, passive: true });
      document.addEventListener('touchstart', syncBeforeSubmit, { capture: true, passive: true });
    }

    form.addEventListener('submit', function () { syncForm(); }, true);

    var productId = form.getAttribute('data-product-id');
    var proxyBase = form.getAttribute('data-app-proxy') || '/apps/alphainfuse';

    fetchBundleConfig(proxyBase, productId).then(function (data) {
      if (!data || !data.bundle) return;
      bundle = data.bundle;
      roundSave = !!bundle.roundSaveAmount;
      if (typeof bundle.subscriptionDiscountPercent === 'number') {
        subscriptionDiscountPercent = bundle.subscriptionDiscountPercent;
      }
      if (bundle.subscriptionEnabled === false) {
        subEnabled = false;
        if (subsRoot) subsRoot.hidden = true;
      }

      if (bundle.subscriptionLabel && subsLabelEl) subsLabelEl.textContent = bundle.subscriptionLabel;
      if (bundle.subscriptionBadge && subsBadgeEl) subsBadgeEl.textContent = bundle.subscriptionBadge;
      if (bundle.subscriptionFrequencyPrefix && subsFreqPrefixEl) {
        subsFreqPrefixEl.textContent = bundle.subscriptionFrequencyPrefix;
      }
      refresh();
    });

    refresh();
  }

  function init() {
    convertUsdElements();
    initPopup();
    initBuy();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();